import { useCallback, useState } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { usePageMeta } from '@/hooks/usePageMeta';
import { usePullToRefresh } from '@/hooks/usePullToRefresh';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickEntry from './components/CategoryQuickEntry';
import RecommendedSection from './components/RecommendedSection';
import LatestUploads from './components/LatestUploads';

export default function Home() {
  usePageMeta({
    title: '抖音 - 短视频内容分享与精彩生活记录平台',
    description:
      '抖音提供海量热门短视频内容，覆盖音乐、搞笑、生活、美食等多领域，用户可以轻松浏览和分享个性短视频，记录精彩生活。',
    keywords: '抖音,短视频,短视频分享,热门短视频,生活记录,短视频平台,抖音视频播放',
  });

  const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = useCallback(() => setRefreshKey((k) => k + 1), []);
  const { pullDistance, refreshing, handlers } = usePullToRefresh(handleRefresh);

  return (
    <div className="min-h-screen bg-background-50" {...handlers}>
      {/* 下拉刷新提示（移动端） */}
      <div
        className="md:hidden fixed top-16 left-0 right-0 z-40 flex items-center justify-center overflow-hidden transition-all"
        style={{ height: pullDistance, opacity: pullDistance > 8 ? 1 : 0 }}
      >
        <span className="flex items-center gap-2 text-xs text-foreground-600">
          <i className={`ri-refresh-line ${refreshing ? 'animate-spin' : ''}`}></i>
          {refreshing ? '正在刷新…' : pullDistance > 45 ? '松开立即刷新' : '下拉刷新'}
        </span>
      </div>

      <Header overlay />
      <main>
        <HeroCarousel />
        <CategoryQuickEntry />
        <RecommendedSection key={refreshKey} />
        <LatestUploads key={`latest-${refreshKey}`} />
      </main>
      <Footer />
    </div>
  );
}